import {
  RESET_FORGOT_PASSWORD_REQUEST,
  SET_IS_FETCHING_FORGOT_PASSWORD,
  SET_IS_FORGOT_PASSWORD_ERROR,
  SET_IS_FORGOT_PASSWORD_SUCCESS,
} from "../actions/actions-types";

const initialState = {
  isFetching: false,
  isSuccess: false,
  isError: false,
};

export const forgotPasswordReducer = (state = initialState, action) => {
  if (action.type === SET_IS_FETCHING_FORGOT_PASSWORD) {
    const { isFetching } = action.payload;
    return {
      ...state,
      isFetching,
    };
  }

  if (action.type === SET_IS_FORGOT_PASSWORD_SUCCESS) {
    const { isSuccess } = action.payload;
    return {
      ...state,
      isSuccess,
    };
  }

  if (action.type === SET_IS_FORGOT_PASSWORD_ERROR) {
    const { isError } = action.payload;
    return {
      ...state,
      isError,
    };
  }

  if (action.type === RESET_FORGOT_PASSWORD_REQUEST) {
    return {
      ...state,
      ...initialState,
    };
  }

  return state;
};
